import Modal from "../../../components/Modal/modal";
import InvoicePaymentModal from "./invoicePaymentModal";
import React, { useEffect, useRef, useState } from "react";
import { useSubscriptionContext } from "../subscriptionContext";
import PaymentProcessingModal from "../InvoiceProcessingModal";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { publishModalData, publishModalProps, publishModalVisibility } from "../../../redux/features/modal/modalSlice";
import Header from "../../header/page";
import { OnCloseReason } from "../interfaces";

const InvoicePageContent = () => {
  const dispatch = useAppDispatch();
  const { isInvoiceProcessing } = useSubscriptionContext();
  const searchParams = new URLSearchParams(location.search);
  const invoiceId = searchParams.get("invoiceId");
  const isModalOpen = useAppSelector(state => state.modal.isOpen);
  const modalData = useAppSelector(state => state.modal.data);
  const modalOverlay = useAppSelector(state => state.modal.withOverlay);

  const onError = (errorCode: "pay_iframe_error" | "create_session_error") => {
    switch (errorCode) {
      case "create_session_error": {
        dispatch(publishModalVisibility({ isOpen: false }));
        const autoClose = 7;
        setTimeout(() => {
          location.href = `/login?ReturnUrl=${encodeURIComponent("/management-subscription")}`;
        }, autoClose * 1000);
      }
    }
  };

  const onClose = (reason: OnCloseReason) => {
    switch (reason) {
      case "closeButtonClicked": {
        location.href = `/login?ReturnUrl=${encodeURIComponent("/management-subscription")}`;
      }
    }
  };

  useEffect(() => {
    if (invoiceId) {
      dispatch(
        publishModalProps({
          withOverlay: false,
        })
      );
      dispatch(
        publishModalData({
          modalData: <InvoicePaymentModal onError={onError} onClose={onClose} invoiceId={invoiceId} />,
        })
      );
      dispatch(publishModalVisibility({ isOpen: true }));
    } else {
      location.href = "/";
    }
  }, [invoiceId]);

  const ref = useRef<HTMLDivElement>();

  const [minimumheight, setMinimumHeight] = useState<string>();

  useEffect(() => {
    if (ref.current) {
      setMinimumHeight(`calc(100vh - ${ref.current.getBoundingClientRect().top}px)`);
    }
  }, [ref.current]);

  return (
    <>
      <header className="sticky top-0 bg-white z-[1003] botb-pass-header">
        <Header renderModalComponentHere={false} isBotBPassHeader={true} />
      </header>
      <div style={{ minHeight: minimumheight }} ref={ref}>
        <Modal body={modalData} title="" isOpen={isModalOpen} withOverlay={modalOverlay} />
        {isInvoiceProcessing && <PaymentProcessingModal />}
      </div>
    </>
  );
};

export default InvoicePageContent;
